/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BcArticleListResponse } from '../../models/bc-article-list-response';

export interface GetAllArticles$Params {
}

export function getAllArticles(http: HttpClient, rootUrl: string, params?: GetAllArticles$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BcArticleListResponse>>> {
  const rb = new RequestBuilder(rootUrl, getAllArticles.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BcArticleListResponse>>;
    })
  );
}

getAllArticles.PATH = '/business-central/articles/all';
